import "./UpcomingMilestone.css";

import { CircleFilledIcon } from "../../../../../assets";
import { UpcomingMilestonePropsWithVariant } from "../../../../../models";
import { getDeadlineColourClass, getFormattedDate } from "../../../../../utils";
import { Avatar } from "../../../../data";

const getDisplayStatus = (status?: string): string => {
  if (!status) {
    return "-";
  }

  return status
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

const UNASSIGNED_USER = "Unassigned";

export const UpcomingMilestone = ({
  name,
  deadlineDate,
  status,
  assigneeName,
  rounded = false,
  onClick,
  variant = "default",
}: UpcomingMilestonePropsWithVariant): JSX.Element => {
  const footerName = assigneeName ?? UNASSIGNED_USER;
  const formattedDate = getFormattedDate(deadlineDate) ?? "-";
  const deadlineColourClass = getDeadlineColourClass(deadlineDate);

  return (
    <div
      className={`UpcomingMilestone ${variant} ${rounded ? "Rounded" : ""}`}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onClick();
        }
      }}
    >
      <div className="UpcomingMilestoneHeader">
        <p className="body2">{name}</p>
      </div>
      <div className="UpcomingMilestoneDetails">
        <div className="UpcomingMilestoneMetaRow">
          <span className="body3 UpcomingMilestoneMetaLabel">Status:</span>
          <span className="body3Light UpcomingMilestoneMetaValue">{getDisplayStatus(status)}</span>
        </div>
        <div className="UpcomingMilestoneMetaRow">
          <span className="body3 UpcomingMilestoneMetaLabel">Deadline:</span>
          <span className={`UpcomingMilestoneDeadline ${deadlineColourClass}`}>
            <CircleFilledIcon aria-hidden="true" />
            <span className="body3Light UpcomingMilestoneMetaValue">{formattedDate}</span>
          </span>
        </div>
      </div>
      <div className="UpcomingMilestoneFooter">
        {footerName !== UNASSIGNED_USER ? (
          <>
            <p className="body3Light">{footerName}</p>
            <div className="UpcomingMilestoneAvatar" aria-hidden="true">
              <Avatar name={footerName} />
            </div>
          </>
        ) : (
          <div className="UpcomingMilestoneFooterPlaceholder" />
        )}
      </div>
    </div>
  );
};
